<div class="signup" [ngClass]="{ landscape_signup: tamWidth < 767 }">
  <div class="signup__content">
    <div class="form">
      <div class="signup__content__header">
        <div class="signup__content__header__title">
          <mat-icon (click)="back()">arrow_forward</mat-icon>
          <span>
            {{ dataTranslateRegister?.title }}
          </span>
        </div>
        <div class="signup__content__header__img">
          <img
            src="https://cdn.mango-soft.com/mango-core/mango-vertical.svg"
            alt=""
          />
        </div>
      </div>
      <form class="signup__content__form" [formGroup]="formRegister">
        <div class="signup__content__form__header">
          <div
            class="signup__content__form__header__inputs"
            [ngClass]="{
              'signup__content__form__header__intputs-row': !configRegister.fieldsView.avatar
            }"
          >
            <div
              class="form-group-mg"
              *ngIf="configRegister.fieldsView.firstName"
            >
              <label for="">
                {{ dataTranslateRegister?.form["firstName"] }}
                <span style="color: red">*</span></label
              >
              <input
                [placeholder]="dataTranslateRegister?.form.placeholderFirstName"
                type="text"
                formControlName="firstName"
              />
              <div
                *ngIf="f['firstName'].touched && f['firstName'].invalid"
                class="alert-error"
              >
                <div *ngIf="f['firstName'].errors['required']">
                  {{ dataTranslateRegister?.form.fieldRequired }}
                </div>
              </div>
            </div>
            <div
              class="form-group-mg"
              *ngIf="configRegister.fieldsView.lastName"
            >
              <label for="">
                {{ dataTranslateRegister?.form.lastName }}
                <span style="color: red">*</span></label
              >
              <input
                [placeholder]="dataTranslateRegister?.form.placeholderLastName"
                type="text"
                formControlName="lastName"
              />
              <div
                *ngIf="f.lastName.touched && f.lastName.invalid"
                class="alert-error"
              >
                <div *ngIf="f.lastName.errors?.required">
                  {{ dataTranslateRegister?.form.fieldRequired }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="signup__content__form__img"
            *ngIf="configRegister.fieldsView.avatar"
          >
            <div
              class="load-image"
              (dragover)="onDragOver()"
              (dragleave)="onDragLeave($event)"
            >
              <label for="">Avatar </label>
              <div
                class="inputDrag-mg"
                [ngClass]="{ 'active-drag': isDragActive }"
              >
                <mat-icon *ngIf="fileUrl === ''" class="mr-2">backup</mat-icon>
                <span *ngIf="fileUrl === ''" style="text-align: center">
                  {{ dataTranslateRegister?.form.textDrag }}
                </span>
                <img
                  *ngIf="fileUrl !== ''"
                  [src]="fileUrl"
                  class="max-h-48"
                  alt=""
                />
                <zf-s3-upload-image
                  [version]="'1'"
                  [url]="
                    'https://res.cloudinary.com/du4jrqkyo/image/upload/v1549938954/picture.jpg'
                  "
                  [urlPresigned]="
                    'https://api-services.mango-soft.com/stage/get-presigned-url'
                  "
                  [bucket]="'cdn.mango-soft.com'"
                  [folder]="'access-control/files'"
                  [client]="'zerofractal'"
                  [imageZoom]="false"
                  (urlUploaded)="urlUploadedHandle($event)"
                  (urlUploadedError)="urlUploadedErrorHandle($event)"
                ></zf-s3-upload-image>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group-mg" *ngIf="configRegister.fieldsView.username">
          <label for="username"
            >{{ dataTranslateRegister?.form.username }}
            <span style="color: red">*</span></label
          >
          <input
            [placeholder]="dataTranslateRegister?.form.placeholderUsername"
            type="text"
            id="username"
            formControlName="username"
            onkeypress="return event.charCode != 32"
            (input)="searchInputUsername($event)"
          />
          <div class="loader loader-username" *ngIf="loadingValidateUsername">
            <span class="loader-input"></span>
          </div>

          <div
            *ngIf="f.username.touched && f.username.invalid"
            class="alert-error"
          >
            <div *ngIf="f.username.errors?.required">
              {{ dataTranslateRegister?.form.fieldRequired }}
            </div>
          </div>
          <div *ngIf="stateUsername" class="alert-error">
            <div>
              {{ dataTranslateRegister?.form.registerUsername }}
            </div>
          </div>
        </div>

        <div class="form-group-mg" *ngIf="configRegister.fieldsView.address">
          <label for="address"
            >{{ dataTranslateRegister?.form.address }}
            <span style="color: red">*</span></label
          >
          <div class="input-group-mg" formGroupName="address">
            <input [placeholder]="'Address'" formControlName="address" />
            <div class="input-group-mg-append">
              <button
                class="mg-button-input btn mg-input text-white"
                type="button"
                (click)="openAddressModal()"
              >
                {{
                  this.formRegister.getRawValue().address.address &&
                  this.formRegister.getRawValue().address.address.length > 0
                    ? dataTranslateRegister?.form.edit
                    : dataTranslateRegister?.form.add
                }}
              </button>
            </div>
          </div>
        </div>
        <div class="form-group-mg" *ngIf="configRegister.fieldsView.email">
          <div
            class="text-send-email"
            *ngIf="
              stateValidateEmail === 'pending' ||
              stateValidateEmail === 'invalid' ||
              (stateValidateEmail === 'loading' && code.length > 3)
            "
          >
            <span> {{ dataTranslateRegister?.form.pleaseEnter }} </span>
            <span class="text-send-email-valid">
              {{ formRegister.getRawValue().email }}
            </span>
          </div>
          <label for="email"
            >{{
              stateValidateEmail === "pending" ||
              stateValidateEmail === "invalid" ||
              (stateValidateEmail === "loading" && code.length > 3)
                ? "Verification code"
                : dataTranslateRegister?.form.email
            }}
            <span style="color: red">*</span></label
          >
          <div class="input-group-mg">
            <input
              placeholder="email_mango@mango-soft.com"
              type="email"
              id="email"
              formControlName="email"
              *ngIf="
                stateValidateEmail === 'default' ||
                stateValidateEmail === 'active' ||
                stateValidateEmail === 'valid' ||
                (stateValidateEmail === 'loading' &&
                  formRegister.getRawValue().email &&
                  code.length === 0)
              "
              (input)="searchInputEmail($event)"
            />
            <div
              class="validate-code-mg"
              *ngIf="
                stateValidateEmail === 'pending' ||
                stateValidateEmail === 'invalid' ||
                (stateValidateEmail === 'loading' && code.length > 3)
              "
            >
              <input
                placeholder="1234"
                type="number"
                id="email"
                (input)="onCodeCompleted($event)"
              />
            </div>
            <div
              class="input-group-mg-append"
              [ngClass]="{
                'input-group-mg-append-extra':
                  stateValidateEmail === 'pending' ||
                  stateValidateEmail === 'invalid' ||
                  (stateValidateEmail === 'loading' &&
                    formRegister.getRawValue().email &&
                    code.length !== 0)
              }"
            >
              <button
                class="mg-button-input btn mg-input text-white"
                type="button"
                *ngIf="stateValidateEmail !== 'valid'"
                [disabled]="
                  stateValidateEmail === 'default' ||
                  (stateValidateEmail === 'pending' && code.length < 3)
                "
                (click)="sendEmailCode()"
              >
                <span *ngIf="stateValidateEmail !== 'loading'">
                  {{ dataTranslateRegister?.form.validate }}
                </span>
                <div
                  class="loader loader-btn"
                  *ngIf="stateValidateEmail === 'loading'"
                >
                  <span class="loader-input"></span>
                </div>
              </button>
            </div>
          </div>
          <div
            class="resend-code-text"
            *ngIf="
              stateValidateEmail === 'pending' ||
              stateValidateEmail === 'invalid' ||
              (stateValidateEmail === 'loading' && code.length > 3)
            "
          >
            <span (click)="sendCode()">
              {{ dataTranslateRegister?.form.resend }}
            </span>
          </div>
          <div *ngIf="f.email.touched && f.email.invalid" class="alert-error">
            <div *ngIf="f.email.errors?.required">
              {{ dataTranslateRegister?.form.fieldRequired }}
            </div>
            <div *ngIf="f.email.errors?.email">
              {{ dataTranslateRegister?.form.fieldInvalidEmail }}
            </div>
          </div>
          <div *ngIf="stateEmail" class="alert-error">
            <div>
              {{ dataTranslateRegister?.form.registerEmail }}
            </div>
          </div>
          <div *ngIf="stateValidateEmail === 'invalid'" class="alert-error">
            <div>{{ dataTranslateRegister?.form.invalidCode }}</div>
          </div>
          <div *ngIf="stateValidateEmail === 'valid'" class="code-text-valid">
            <span>
              {{ dataTranslateRegister?.form.emailVerified }}
            </span>
            <mat-icon>check_circle</mat-icon>
          </div>
        </div>
        <div class="form-group-mg" *ngIf="configRegister.fieldsView.phone">
          <label for="phone"
            >{{ dataTranslateRegister?.form.phone }}
            <span style="color: red">*</span></label
          >
          <ngx-intl-tel-input
            [cssClass]="'custom'"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            id="phone"
            [searchCountryFlag]="true"
            [maxLength]="15"
            [searchCountryPlaceholder]="
              dataTranslateRegister?.form.placeholderPhone
            "
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name
            ]"
            formControlName="phone"
            [selectFirstCountry]="false"
            [selectedCountryISO]="selectedCountryISO"
            [phoneValidation]="true"
            [separateDialCode]="separateDialCode"
            [numberFormat]="PhoneNumberFormat.International"
            name="phone"
            (countryChange)="validatePhone($event)"
            (input)="validatePhone($event)"
          >
          </ngx-intl-tel-input>
          <div *ngIf="f.phone.touched && f.phone.invalid" class="alert-error">
            <div *ngIf="f.phone.errors?.required">
              {{ dataTranslateRegister?.form.fieldRequired }}
            </div>
            <div
              *ngIf="
                !f.phone.errors?.validatePhoneNumber?.valid &&
                !f.phone.errors?.required &&
                !statePhone
              "
            >
              {{ dataTranslateRegister.form.phoneValid }}
            </div>
          </div>
          <div *ngIf="statePhone" class="alert-error">
            <div>
              {{ dataTranslateRegister.form.registerPhone }}
            </div>
          </div>
        </div>
        <div class="form-group-mg" *ngIf="configRegister.fieldsView.password">
          <label for="password"
            >{{ dataTranslateRegister?.form["password"] }}
            <span style="color: red">*</span></label
          >
          <div class="input-password">
            <input
              autocomplete="new-password"
              placeholder="**************"
              id="password"
              [type]="activeVisibilityPassword ? 'text' : 'password'"
              formControlName="password"
            />
            <mat-icon
              (click)="activeVisibilityPassword = !activeVisibilityPassword"
              >{{
                activeVisibilityPassword ? "visibility" : "visibility_off"
              }}</mat-icon
            >
          </div>
          <div
            *ngIf="f['password'].touched && f['password'].invalid"
            class="alert-error"
          >
            <div *ngIf="f['password'].errors?.required">
              {{ dataTranslateRegister?.form.fieldRequired }}
            </div>
          </div>
        </div>
        <div
          class="form-group-mg"
          *ngIf="configRegister.fieldsView.confirmPassword"
        >
          <label for="confirmPassword"
            >{{ dataTranslateRegister?.form["confirmPassword"] }}
            <span style="color: red">*</span></label
          >
          <div class="input-password">
            <input
              autocomplete="new-password2"
              placeholder="**************"
              id="confirmPassword"
              formControlName="confirmPassword"
              [type]="activeVisibilityConfirmPassword ? 'text' : 'password'"
            />
            <mat-icon
              (click)="
                activeVisibilityConfirmPassword =
                  !activeVisibilityConfirmPassword
              "
              >{{
                activeVisibilityConfirmPassword
                  ? "visibility"
                  : "visibility_off"
              }}</mat-icon
            >
          </div>
          <div
            *ngIf="f['confirmPassword'].touched && f['confirmPassword'].invalid"
            class="alert-error"
          >
            <div *ngIf="f['confirmPassword'].errors?.required">
              {{ dataTranslateRegister?.form.fieldRequired }}
            </div>
            <div *ngIf="f['confirmPassword'].errors['password']; mismatch">
              {{ dataTranslateRegister?.form.password.NotMatch }}
            </div>
          </div>
        </div>
        <div class="tems-conditions">
          <div
            class="tems-conditions-item"
            *ngIf="configRegister.fieldsView.terms"
          >
            <mat-checkbox class="example-margin" formControlName="terms">
            </mat-checkbox>
            <p class="tems-conditions-item-text">
              <span> {{ dataTranslateRegister?.form.textAccept }} </span>
              <a (click)="redirectTerms()">{{
                dataTranslateRegister?.form.terms
              }}</a>
            </p>
          </div>
          <div
            class="tems-conditions-item"
            *ngIf="configRegister.fieldsView.policy"
          >
            <mat-checkbox class="example-margin" formControlName="policy">
            </mat-checkbox>
            <p class="tems-conditions-item-text">
              <span> {{ dataTranslateRegister?.form.textAccept }} </span>
              <a (click)="redirectPrivacy()">
                {{ dataTranslateRegister?.form.privacy }}</a
              >
            </p>
          </div>
        </div>
        <div class="save">
          <button
            class="button_save_register"
            (click)="save()"
            [disabled]="
              formRegister.invalid ||
              stateEmail ||
              statePhone ||
              stateUsername ||
              loading ||
              stateValidateEmail !== 'valid'
            "
          >
            <span *ngIf="!loading">
              {{ dataTranslateRegister?.form.buttonSave }}
            </span>
            <div class="loader" *ngIf="loading" style="padding: 2px">
              <span class="loader-input"></span>
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="landscape_logo"></div>
</div>
